/**
 * Registro de Habilidades do 1º e 2º ano e da Educação Infantil.
 *
 * Nessas séries a aba Notas do diário vira "Habilidades": em vez de nota, um
 * conceito por habilidade em cada bimestre. Na Educação Infantil é a Matriz de
 * Acompanhamento do Desenvolvimento Infantil, por Campo de Experiência. A regra
 * que decide a série é a mesma do servidor (backend/api/habilidades.py —
 * `serie_de_habilidades`).
 */

export const CONCEITOS = ['HND', 'HDI', 'HD', 'HC'];

// Cores dos conceitos: as mesmas do PDF (backend/api/registro_habilidades_pdf.py).
export const COR_DO_CONCEITO = {
  HND: '#E83A3C',
  HDI: '#F59E0B',
  HD: '#3B82F6',
  HC: '#16A34A',
};

const semAcento = (texto) =>
  String(texto || '')
    .normalize('NFKD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase()
    .split(/\s+/)
    .filter(Boolean)
    .join(' ');

const ROMANOS = { 1: 'I', 2: 'II', 3: 'III', 4: 'IV', 5: 'V' };

/**
 * '1º Ano', '2º Ano' ou 'Infantil I' a 'Infantil V' quando a turma usa o
 * Registro de Habilidades; null nas demais séries. Aceita '1° ano', '1 Ano',
 * '1o Ano' — mas não '1º Ano EM' — e 'Inf 1', 'Inf. 2', 'Infantil IV' — mas
 * não 'Berçário I'.
 */
export function serieDeHabilidades(grade) {
  const nome = semAcento(grade);
  // NFKD troca "º" por "o", como no servidor.
  const ano = /^([12])\s*[o°]?\s*ano$/.exec(nome);
  if (ano) return `${ano[1]}º Ano`;
  const infantil = /^inf(?:antil)?\.?\s*([1-5]|i{1,3}|iv|v)$/.exec(nome);
  if (infantil) return `Infantil ${ROMANOS[infantil[1]] || infantil[1].toUpperCase()}`;
  return null;
}

/** Educação Infantil: a matriz é da turma, por Campo de Experiência. */
export const ehInfantil = (serie) => /^Infantil /.test(serie || '');

/** Chave do conceito no mapa da tela. */
export const chaveConceito = (idAluno, idHabilidade, bimestre) =>
  `${idAluno}:${idHabilidade}:${bimestre}`;
